import key from "../../../assets/images/settings/key.svg";
import alert from "../../../assets/images/settings/alert.svg";
import company from "../../../assets/images/settings/company.svg";
import integrations from "../../../assets/images/settings/integrations.svg";
import user from "../../../assets/images/settings/user.svg";
import doc from "../../../assets/images/settings/doctype/doc.svg";
import pdf from "../../../assets/images/settings/doctype/pdf.svg";
import portfolio from "../../../assets/images/settings/portfolio.svg";
import portfolioProfile from "../../../assets/images/settings/portfolioProfile.svg";

export const header = {
  myprofile: {
    title: "MY PROFILE",
    subtitle: "Edit & update your personal information and set a new password",
    img: user,
  },
  Companysettings: {
    title: "COMPANY SETTINGS",
    subtitle:
      "Edit & update your business info: Name, Logo, address or phone number.Update your business’s legal information",
    img: company,
  },
  portfolioProfile: {
    title: "PORTFOLIO PROFILE",
    subtitle: "Define your clusters, permitted users, discount rates etc.",
    img: portfolioProfile,
  },
  portfolioregistration: {
    title: "PORTFOLIO REGISTRATION",
    subtitle: "Edit & update your portfolio details",
    img: portfolio,
  },
  userspermissions: {
    title: "MANAGE USER PERMISSIONS",
    subtitle: "Add / remove new users & team members  and set their permissions",
    img: key,
  },
  alertsnotifications: {
    title: "ALERTS & NOTIFICATIONS",
    subtitle: "Manage the types of email notifications you’d like to receive and their scheduling",
    img: alert,
  },
  prassintegrations: {
    title: "PRaaS INTEGRATIONS",
    subtitle: "Pick your preferred sys. integrations you’d like PropertyPower to connect to",
    img: integrations,
  },
};

export const LANGUAGES = [
  "Mandarin Chinese",
  "Spanish",
  "English",
  "Hindi/Urdu",
  "Arabic",
  "Bengali",
  "Portuguese",
  "Russian",
  "Japanese",
  "German",
  "Javanese",
  "Punjabi",
  "Wu",
  "French",
  "Telugu",
  "Vietnamese",
  "Marathi",
  "Korean",
  "Tamil",
  "Italian",
  "Turkish",
  "Cantonese/Yue",
];

export const CURRENCY = ["USD", "EUR", "GBP"];

export const UNIT_SYSTEM = ["SQFT", "SQM"];

export const docType = [
  {
    docName: "document name comes here",
    docDate: "July 10, 2020",
    docSize: "26.9 Mb",
    docIcon: pdf,
  },
  {
    docName: "document long long name comes here.docx",
    docDate: "July 10, 2020",
    docSize: "26.9 Mb",
    docIcon: doc,
  },
];
export const users = [
  {
    shortName: "KR",
    email: "Kyle.Robertson@arthur.com",
    name: "Kyle Robertson",
  },
  {
    shortName: "KR",
    email: "Kyle.Robertson@arthur.com",
    name: "Kyle Robertson",
  },
  {
    shortName: "KR",
    email: "Kyle.Robertson@arthur.com",
    name: "Kyle Robertson",
  },
];

export const options = [
  {
    id: 0,
    value: "EXECUTIVE",
    label: "Executive",
  },
  {
    id: 1,
    value: "OPERATOR",
    label: "Operator",
  },
  {
    id: 2,
    value: "BASIC",
    label: "Basic",
  },
  {
    id: 3,
    value: "ADMIN",
    label: "Admin",
  },
];
export const timeOption = [
  {
    id: 0,
    value: "WEEKLY",
    label: "weekly",
  },
  {
    id: 1,
    value: "DAILY",
    label: "daily",
  },
  {
    id: 2,
    value: "YEARLY",
    label: "yearly",
  },
  {
    id: 3,
    value: "HOURLY",
    label: "hourly",
  },
];

export const manageUser = [
  {
    id: 4,
    first_name: "billu",
    last_name: "sanda",
    email: "billu-moss@mail.com",
    profile_image: null,
    role: "ADMIN",
    currency: "USD",
    preferred_language: "ENGLISH",
  },
  {
    id: 5,
    first_name: "gullu",
    last_name: "sullu",
    email: "gjohnson-moss@mail.com",
    profile_image: null,
    role: "ADMIN",
    currency: "USD",
    preferred_language: "ENGLISH",
  },
];

export const alerts = [
  {
    label: "Tenancy management",
    value: "tenancy_management",
  },
  {
    label: "Leasing  Opportunities alerts",
    value: "leasing_opportunities",
  },
  {
    label: "Emission Impact",
    value: "emission_impact",
  },
  {
    label: "New Power Assets",
    value: "new_power_assets",
  },
  {
    label: "Buildings Maintenance",
    value: "buildings_maintenance",
  },
];

export const notifications = [
  {
    label: "Vacancies updates done by building manager",
    value: "vacancies_updates",
  },
  {
    label: "Leasing expiration due date is in 60d",
    value: "leasing_expiration",
  },
];

export const userProfile = {
  currency: "USD",
  email: "jjenkins@mail.com",
  first_name: "Joanne",
  id: 2,
  last_name: "Jenkins",
  preferred_language: "English",
  profile_image: null,
  role: "Admin",
};

export const AppName = [
  "App name comes here",
  "App name comes here",
  "App name comes here",
  "App name comes here",
  "App name comes here",
];
